import React from 'react'

const Odometer = ({ width = '64px', height = '64px', color }) => (
  <svg version={1.1} id="Layer_1" x="0" y="0" viewBox="0 0 512 512" xmlSpace="preserve" width={width} height={height}>
    <path
      fill="none"
      stroke={color}
      strokeWidth={20}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M41.127 340.67c-5.523 0-10-4.478-10-10V176.706c0-5.523 4.477-10 10-10H472c5.522 0 10 4.477 10 10V330.67c0 5.522-4.478 10-10 10H41.127zM365.995 168.813V338.09M256.038 168.813V338.09M146.081 168.813V338.09"
    />
    <g fill="none" stroke={color} strokeWidth={20} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10}>
      <path d="M68.275 295.507s45.444-.949 45.444-43.439c0-9.285.349-8.247.21-15.719" />
      <circle cx={89.816} cy={235.384} r={24.113} />
    </g>
    <g fill="none" stroke={color} strokeWidth={20} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10}>
      <path d="M179.339 295.507s45.444-.949 45.444-43.439c0-9.285.349-8.247.21-15.719" />
      <circle cx={200.88} cy={235.384} r={24.113} />
    </g>
    <g fill="none" stroke={color} strokeWidth={20} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10}>
      <path d="M289.253 295.507s45.444-.949 45.444-43.439c0-9.285.349-8.247.21-15.719" />
      <circle cx={310.795} cy={235.384} r={24.113} />
    </g>
    <g fill="none" stroke={color} strokeWidth={20} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10}>
      <path d="M435.507 339c6.262-6.061 11.859-18.139 11.859-30.272 0-9.285-.211-7.036-.35-14.508" />
      <circle cx={422.903} cy={293.256} r={24.113} />
    </g>
    <path
      fill="none"
      stroke={color}
      strokeWidth={20}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M438.782 170.345c5.047 4.65 8.234 11.48 8.234 19.092 0 14.011-10.796 25.369-24.113 25.369s-24.113-11.358-24.113-25.369c0-7.006 2.699-13.348 7.063-17.939"
    />
  </svg>
)
export default Odometer
